import { InfoIcon, ShieldAlertIcon, TriangleAlertIcon } from 'lucide-react';

import { TaskCriticalityEnum, type ITaskCount } from 'src/graphql/schema';

export const CRITICALITY_CONFIG: Record<
  TaskCriticalityEnum,
  {
    priority: number;
    icon: typeof InfoIcon;
    bannerClassName: string;
    iconWrapperClassName: string;
    dotClassName: string;
  }
> = {
  [TaskCriticalityEnum.High]: {
    priority: 1,
    icon: ShieldAlertIcon,
    bannerClassName: 'border-red-200 bg-red-100',
    iconWrapperClassName: 'bg-destructive text-white',
    dotClassName: 'bg-destructive',
  },
  [TaskCriticalityEnum.Medium]: {
    priority: 2,
    icon: TriangleAlertIcon,
    bannerClassName: 'border-orange-200 bg-orange-100',
    iconWrapperClassName: 'bg-orange-500 text-white',
    dotClassName: 'bg-orange-500',
  },
  [TaskCriticalityEnum.Low]: {
    priority: 3,
    icon: InfoIcon,
    bannerClassName: 'border-sky-200 bg-sky-100',
    iconWrapperClassName: 'bg-sky-500 text-white',
    dotClassName: 'bg-sky-500',
  },
};

export const CRITICALITY_ORDER = Object.values(TaskCriticalityEnum).sort(
  (a, b) => CRITICALITY_CONFIG[a].priority - CRITICALITY_CONFIG[b].priority,
);

export const getWorstCriticality = (
  taskCounts: Pick<ITaskCount, 'criticality' | 'count'>[],
): TaskCriticalityEnum | null =>
  taskCounts
    .filter((taskCount) => taskCount.count > 0)
    .reduce<TaskCriticalityEnum | null>(
      (worst, taskCount) =>
        !worst || CRITICALITY_CONFIG[taskCount.criticality].priority < CRITICALITY_CONFIG[worst].priority
          ? taskCount.criticality
          : worst,
      null,
    );
